import PropTypes from "prop-types";
export default PropTypes.shape({
  type: PropTypes.string.isRequired,
  url: PropTypes.string,
  idpIdentifier: PropTypes.string
})